import React, { Component } from 'react';
import { localStorageSetItem, localStorageGetItem } from '../../../storage';
import ApiManager from '../../../apiManager';
import { trans } from '../../../helpers';

class B2bLanguageList extends Component {

    constructor( props ){
        super( props );

        this.componentIsMounted = true;
    }

    componentWillUnmount() {

        this.componentIsMounted = false;

    }

    changeLanguage( lngPrefix ){

        if ( lngPrefix === localStorageGetItem('defaultLngPrefix') ) {
            return;
        }

        localStorageSetItem( 'defaultLngPrefix', lngPrefix );

        ApiManager.getB2bTranslations().then(( resolve ) => {

            if ( !this.componentIsMounted ) {
                return;
            }
            this.props.setTranslationsAction( resolve.data );

            if ( this.props.hasOwnProperty('languageChange') ) {
                this.props.languageChange();
            }

        }, () => this.props.updateParentState({ showErrorModal: true }));

    }

    render () {

        const list = ['en', 'hy', 'ru'].map(( item, index ) => {
            return (
                <li className="main-wrapper__language-item ver-top-box" key={index}>
                    <button
                        className={`main-wrapper__language-link db fs12${item === localStorageGetItem( 'defaultLngPrefix') ? ' fb' : ''}`}
                        type="button"
                        onClick={() => this.changeLanguage( item )}
                    >{trans(this.props.b2bTrans, 'b2b.lng_' + item)}</button>
                </li>
            );
        });

        return (
            <ul className="main-wrapper__language-list fr">{list}</ul>
        );

    };

}

export default B2bLanguageList;